module.exports = __webpack_public_path__ + "img/LogoOficialFinerFoods.fe28426d.png";